import type { HTTPError } from 'ky';

import type { ToastMessage } from '~/components/Toast';
import { HttpStatusCode } from '~settings/api/lib/types';

export const getErrorMessage = (error: HTTPError): ToastMessage => {
  const status = error?.response?.status as HttpStatusCode;

  switch (status) {
    case HttpStatusCode.EntityConflict: {
      return {
        title: 'sublabelRequest.errors.entityConflict.title',
        description: 'sublabelRequest.errors.entityConflict.message',
      };
    }
    case HttpStatusCode.BadRequest: {
      return {
        title: 'sublabelRequest.errors.validation.title',
        description: 'sublabelRequest.errors.validation.message',
      };
    }
    default:
      return {
        title: 'sublabelRequest.errors.generic.title',
        description: 'sublabelRequest.errors.generic.message',
      };
  }
};
